// Desc: generic state for for pcb fabrication
import { START } from 'pu-data/QuoteSteps';
import defaultParameters from './defaultParameters';
import defaultSuppliers from './defaultSuppliers';
import { OFFSHORE_PCB_ID } from './productVariants';

const state = {
  loading: false,
  parameters: defaultParameters,
  parametersChanged: false,
  suppliers: defaultSuppliers,
  quoteStep: START,
  quote: {},
  currentVariant: OFFSHORE_PCB_ID,
  destroy: false,
  lineItemId: null,
  quantitiesChanged: false,
};

export default state;
